import React from 'react';
import { Button, ButtonGroup, Grid, Tooltip } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import theme from '../Styles/MuiTheme';

const PickerColor = ({ colors, handleColorChange }) => {

    const [selectedColor, setSelectedColor] = React.useState(null);

    const onClick = (color) => {
        setSelectedColor(color)
        handleColorChange(color)
    }

    return (
        <ThemeProvider theme={theme}>
            <Grid container spacing={1} direction={'row'} alignContent={'center'} marginTop={'1px'}>
                {Object.entries(colors).map(([name, rgb], index) => (
                    <Grid item key={index}  >
                        <Tooltip title={name} >
                            <Button
                                size="large"
                                sx={{
                                    backgroundColor: rgb,
                                    borderRadius: '50%',
                                    maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px',
                                    border: selectedColor === rgb ? `4px solid ${theme.palette.primary.main}` : `2px solid ${theme.palette.blue.main}`,
                                }}
                                onClick={() => onClick(rgb)}
                            />
                        </Tooltip>
                    </Grid>
                ))}
            </Grid>
        </ThemeProvider>
    );
};

export default PickerColor;